import { render } from "./navLinks.vue?vue&type=template&id=1932af52"
import script from "./navLinks.vue?vue&type=script&lang=js"
export * from "./navLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__